module.exports = __webpack_public_path__ + "static/media/GHS07.73dcb28e.png";